import script from "./MaterialOrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialOrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./MaterialOrderDetail.vue?vue&type=style&index=0&id=cc2b6bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc2b6bf2"]])

export default __exports__